var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageCenterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1011_43025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3346 2.5H2.66797C1.65964 2.5 0.834636 3.34375 0.834636 4.375V15.625C0.834636 16.6563 1.65964 17.5 2.66797 17.5H17.3346C18.343 17.5 19.168 16.6563 19.168 15.625V4.375C19.168 3.34375 18.343 2.5 17.3346 2.5Z",
    stroke: "#878786",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.834636 4.1665L10.0013 10.8332L19.168 4.1665",
    stroke: "#878786",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1011_43025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCenterOff);
export default __webpack_public_path__ + "static/media/message-center-off.5d7cca7af08ea3c2ff4e5742eb7fafba.svg";
export { ForwardRef as ReactComponent };